import React, { FC, useState } from 'react';

import { Team } from '../../../database.schema';
import * as CSS from './team-name-styles';
import { UpdateButton } from './update-button';

type TeamNameEntryProps = {
  teamNumber: number;
  teamDetails: Team;
  tournamentIndex: number;
  colour: string;
};
export const TeamNameEntry: FC<TeamNameEntryProps> = ({ teamNumber, teamDetails, tournamentIndex, colour }) => {
  const [updateStatus, setUpdateStatus] = useState({ success: false, error: false });
  const [teamName, setTeamName] = useState<string>(teamDetails.name);

  return (
    <CSS.TeamWrapper borderColor={colour}>
      <h3>Team {teamNumber} Name</h3>
      <form onSubmit={(event) => event.preventDefault()}>
        <CSS.NameWrapper>
          <input
            type="text"
            autoComplete="off"
            name={`team${teamNumber}-name`}
            id={`team${teamNumber}-name`}
            data-testid={`team${teamNumber}-name`}
            value={teamName}
            onChange={(e) => {
              setTeamName(e.target.value);
            }}
          />
        </CSS.NameWrapper>
      </form>
      <div>
        <UpdateButton
          team={`team${teamNumber}`}
          teamDetails={{ ...teamDetails, name: teamName }}
          tournamentIndex={tournamentIndex}
          setUpdateStatus={setUpdateStatus}
          disabled={teamName === teamDetails.name}
        />
      </div>
      <CSS.UpdateStatusWrapper data-testid={`team${teamNumber}-update-status`} color={updateStatus.error ? 'red' : 'green'}>
        {updateStatus.error && <div>Update failed!!!!</div>}
        {updateStatus.success && <div>Updated!!!!</div>}
      </CSS.UpdateStatusWrapper>
    </CSS.TeamWrapper>
  );
};
